__turbopack_context__.v({
  "buttonWrapper": "past-canceled-trips-module__FxzHGq__buttonWrapper",
  "loadingWrapper": "past-canceled-trips-module__FxzHGq__loadingWrapper",
  "scrollPaddingContainer": "past-canceled-trips-module__FxzHGq__scrollPaddingContainer",
  "wrapper": "past-canceled-trips-module__FxzHGq__wrapper",
});
